import { create } from 'zustand';

type LeavePending = { onResolved: (confirmed: boolean) => void };

type ManualEnquiryLeaveGuardState = {
  shouldBlock: boolean;
  setShouldBlock: (v: boolean) => void;
  discard: (() => void) | null;
  setDiscard: (fn: (() => void) | null) => void;
  pending: LeavePending | null;
  requestLeaveConfirmation: (onResolved: (confirmed: boolean) => void) => void;
  resolveLeaveConfirmation: (confirmed: boolean) => void;
};

/** Sidebar / parent-tab leave prompts use this via `getState()`; UI lives in EnquiryV2. */
export const manualEnquiryLeaveGuardStore = create<ManualEnquiryLeaveGuardState>((set, get) => ({
  shouldBlock: false,
  setShouldBlock: (v) => set({ shouldBlock: v }),
  discard: null,
  setDiscard: (fn) => set({ discard: fn }),
  pending: null,
  requestLeaveConfirmation: (onResolved) => {
    if (!get().shouldBlock) {
      onResolved(true);
      return;
    }
    set({ pending: { onResolved } });
  },
  resolveLeaveConfirmation: (confirmed) => {
    const p = get().pending;
    set({ pending: null });
    if (confirmed) {
      p?.onResolved(true);
      set({ shouldBlock: false });
    } else {
      p?.onResolved(false);
    }
  },
}));
